// removed by extract-text-webpack-plugin
module.exports = {"main":"_2QrqVtCwZM6RSGCd28jNWh"};


//////////////////
// WEBPACK FOOTER
// ./src/base/layout/mainLayout.css
// module id = 505
// module chunks = 0